import React, { useEffect, useState, useRef } from 'react';
import { TabOptions } from '../../../../../../../cronGeneratorState/cronGeneratorContext';
import { Radio, Select } from 'antd';
import Text from 'components/Text/Text';
import style from './EveryBetweenSelect.module.scss';

const { Option } = Select;

interface IEveryBetweenSelect {
	onSetResult: (value: string) => void;
}

const EveryBetweenSelect: React.FC<IEveryBetweenSelect> = ({ onSetResult }) => {
	const parentNodeRef1 = useRef<null | HTMLDivElement>(null);
	const parentNodeRef2 = useRef<null | HTMLDivElement>(null);
	const everyBetweenValues = Array.from(Array(24), (_, i) => ('0' + i).slice(-2));

	const [startValue, setStartValue] = useState<string>(everyBetweenValues[0]);
	const [endValue, setEndValue] = useState<string>(everyBetweenValues[0]);

	const result = `${startValue.replace(/^0/, '')}-${endValue.replace(/^0/, '')}`;

	useEffect(() => {
		onSetResult(result);
	}, [result]);

	return (
		<div className={style.radioField}>
			<Radio value={TabOptions.EVERY_BETWEEN_OPTION} id={TabOptions.EVERY_BETWEEN_OPTION + 'hoursTab'} />
			<div className={style.selectContainer}>
				<label className={style.label} htmlFor={TabOptions.EVERY_BETWEEN_OPTION + 'hoursTab'}>
					<Text translationNameSpace="form" translationKey="everyHourBetweenHourLabel" asFragment={true} />
				</label>
				<span ref={parentNodeRef1} style={{ position: 'relative' }} />
				<Select
					className={style.select}
					value={startValue}
					onChange={setStartValue}
					showArrow={true}
					getPopupContainer={() => parentNodeRef1.current as HTMLDivElement}
					listItemHeight={everyBetweenValues.length}>
					{everyBetweenValues.map((el) => (
						<Option className={style.listItem} value={el} key={el}>
							{el}
						</Option>
					))}
				</Select>
				<label className={style.label} htmlFor={TabOptions.EVERY_BETWEEN_OPTION + 'hoursTab'}>
					<Text translationNameSpace="form" translationKey="andHourLabel" asFragment={true} />
				</label>
				<span ref={parentNodeRef2} style={{ position: 'relative' }} />
				<Select
					className={style.select}
					defaultValue={endValue}
					onChange={setEndValue}
					showArrow={true}
					getPopupContainer={() => parentNodeRef2.current as HTMLDivElement}
					listItemHeight={everyBetweenValues.length}>
					{everyBetweenValues.map((el) => (
						<Option className={style.listItem} value={el} key={el}>
							{el}
						</Option>
					))}
				</Select>
			</div>
		</div>
	);
};

export default React.memo(EveryBetweenSelect);
